import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { BUSINESS, IMG } from "../data/site";
import { useLanguage, usePath } from "../i18n/LanguageContext";

export const CTAButtons = ({ dark = false, testidPrefix = "cta" }) => {
  const { t } = useLanguage();
  const p = usePath();
  return (
    <div className="flex flex-wrap gap-3">
      <Link
        to={p("/contact")}
        data-testid={`${testidPrefix}-request-quote-button`}
        className="px-7 py-3.5 text-sm font-bold bg-amber-600 text-white hover:bg-amber-700 transition-colors flex items-center gap-2"
      >
        {t.nav.quote} <ArrowRight className="h-4 w-4" />
      </Link>
      <a
        href={BUSINESS.phoneHref}
        data-testid={`${testidPrefix}-call-now-button`}
        className={`px-7 py-3.5 text-sm font-bold border-2 transition-colors flex items-center gap-2 ${
          dark
            ? "border-white text-white hover:bg-white hover:text-slate-950"
            : "border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white"
        }`}
      >
        <Phone className="h-4 w-4" /> {t.nav.callNow}
      </a>
    </div>
  );
};

export const CTASection = () => {
  const { t } = useLanguage();
  return (
    <section className="relative overflow-hidden bg-slate-950" data-testid="cta-section">
      <img src={IMG.warehouse} alt="Warehouse with pallets" className="absolute inset-0 w-full h-full object-cover opacity-25" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/80 to-slate-950/40" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 lg:py-28">
        <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-amber-500 font-semibold mb-4">{t.cta.overline}</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-2xl leading-tight" data-testid="cta-section-title">
          {t.cta.title}
        </h2>
        <p className="mt-4 text-base sm:text-lg text-slate-300 max-w-xl leading-relaxed">{t.cta.text}</p>
        <div className="mt-8">
          <CTAButtons dark testidPrefix="cta-section" />
        </div>
      </div>
    </section>
  );
};

export const PageHero = ({ overline, title, intro, img }) => (
  <section className="relative overflow-hidden bg-slate-950" data-testid="page-hero">
    <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" loading="lazy" />
    <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/75 to-slate-950/30" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 lg:py-28">
      <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-amber-500 font-semibold mb-4" data-testid="page-hero-overline">{overline}</p>
      <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight max-w-3xl" data-testid="page-hero-title">
        {title}
      </h1>
      {intro && (
        <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-2xl leading-relaxed" data-testid="page-hero-intro">{intro}</p>
      )}
    </div>
  </section>
);
